module.exports = __webpack_public_path__ + "assets/714fece7331a8557576946a26cde8ccd-DSC_0744.jpg";